import React, { Component } from "react";
import { Input, Collapsible, CollapsibleItem } from "react-materialize";

import DateIntervalPicker from "../date-interval-picker/DateIntervalPicker";
import StringUtils from "../../utils/StringUtils";
import EventUtils from "../../utils/EventUtils";

import "./Aggregations.css";

class Aggregations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fixedFilters: {},
      intervalFilters: [],
      aggregations: [],
      cleaning: false,
    };

    this._checkboxes = [];
    this._datepickers = [];

    this.clear = this.clear.bind(this);
    this._handleCheckboxChange = this._handleCheckboxChange.bind(this);
    this._handleIntervalChange = this._handleIntervalChange.bind(this);
  }

  get fixedFilters() {
    return this.state.fixedFilters;
  }

  set fixedFilters(fixedFilters) {
    this.setState({ fixedFilters: fixedFilters });
  }

  get intervalFilters() {
    return this.state.intervalFilters;
  }

  set intervalFilters(intervalFilters) {
    this.setState({ intervalFilters: intervalFilters });
  }

  get aggregations() {
    return this.state.aggregations;
  }

  set aggregations(aggregations) {
    this.setState({ aggregations: aggregations });
  }

  clear() {
    this.setState({ cleaning: true }, () => {
      for (let i in this._checkboxes) {
        if (this._checkboxes[i] === null) {
          continue;
        }

        this._checkboxes[i].state.checked = false;
      }

      for (let i in this._datepickers) {
        if (this._datepickers[i] === null) {
          continue;
        }

        this._datepickers[i].clear(false);
      }

      document
        .querySelectorAll(".aggregators input")
        .forEach((checkbox) => (checkbox.checked = false));

      let fixedFilters = this.fixedFilters;
      for (let key in fixedFilters) {
        fixedFilters[key] = null;
      }

      this.setState(
        { fixedFilters: fixedFilters, intervalFilters: {}, cleaning: false },
        () => {
          EventUtils.raiseEvent(
            "changed",
            { fixedFilters: fixedFilters, intervalFilters: {} },
            this.props
          );
        }
      );
    });
  }

  _handleCheckboxChange(event) {
    const { cleaning, intervalFilters } = this.state;
    if (cleaning) {
      return;
    }

    let checkbox = event.target;
    let fixedFilters = this.state.fixedFilters;
    let filter = fixedFilters[checkbox.name];

    if (checkbox.checked) {
      if (!filter) {
        filter = [];
      }

      filter.push(checkbox.value);
    } else {
      filter = filter.filter((value) => value !== checkbox.value);

      if (filter.length === 0) {
        filter = null;
      }
    }

    fixedFilters[checkbox.name] = filter;
    this.setState({ fixedFilters: fixedFilters }, () => {
      let detail = {
        fixedFilters: fixedFilters,
        intervalFilters: intervalFilters,
      };
      EventUtils.raiseEvent("changed", detail, this.props);
    });
  }

  _handleIntervalChange(event) {
    const { cleaning, fixedFilters, aggregations } = this.state;
    if (cleaning) {
      return;
    }

    let intervalDetail = event.detail;
    let intervalFilters = this.state.intervalFilters;
    let aggregation = aggregations[intervalDetail.name];

    let intervalFilter = {
      field: aggregation.field,
      beginDate: intervalDetail.beginDate,
      endDate: intervalDetail.endDate,
    };

    intervalFilters[aggregation.id] = intervalFilter;

    this.setState({ selectedFilters: intervalFilters }, () => {
      let detail = {
        fixedFilter: fixedFilters,
        intervalFilters: intervalFilters,
      };
      EventUtils.raiseEvent("changed", detail, this.props);
    });
  }

  _getAggregationDisplayName(aggregation) {
    let field = aggregation.field;

    if (field.includes(":")) {
      field = field.split(":")[1];
    }

    field = StringUtils.toCapitalizedWords(field);

    switch (field) {
      case "Ba Rep":
        field = "BA Rep";
        break;
      case "Lmsi Office":
        field = "LMSI Office";
        break;
      case "Archive Classification":
        field = "File Type";
        break;
      case "Live Classification":
        field = "File Type";
        break;
      case "Workfront Project Job Id":
        field = "Job ID";
        break;
      case "Job Start Date":
        field = "Job Date Range";
        break;
      default:
        break;
    }

    return field;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.aggregations === nextState.aggregations) {
      return false;
    }
    return true;
  }

  render() {
    const { aggregations, fixedFilters } = this.state;

    let sortedAggregationsData = Object.values(aggregations).sort(
      (a, b) => (a.field > b.field ? 1 : b.field > a.field ? -1 : 0)
    );

    return (
      <div className="aggregators">
        <Collapsible>
          {sortedAggregationsData
            .filter((aggregation) => aggregation.buckets.length !== 0)
            .map((aggregation) => {
              if (aggregation.field.includes("Date")) {
                let startDate =
                  aggregation.buckets.length > 0
                    ? aggregation.buckets[0].key
                    : "";
                let endDate =
                  aggregation.buckets.length > 0
                    ? aggregation.buckets[aggregation.buckets.length - 1].key
                    : "";
                return (
                  <CollapsibleItem
                    header={this._getAggregationDisplayName(aggregation)}
                    key={aggregation.id}>
                    {
                      <div>
                        <DateIntervalPicker
                          ref={(element) => this._datepickers.push(element)}
                          name={aggregation.id}
                          onChange={this._handleIntervalChange}
                          beginDate={new Date(startDate.split("T")[0])}
                          endDate={new Date(endDate.split("T")[0])}
                        />
                      </div>
                    }
                  </CollapsibleItem>
                );
              } else {
                return (
                  <CollapsibleItem
                    header={this._getAggregationDisplayName(aggregation)}
                    key={aggregation.id}>
                    {aggregation.buckets.map((bucket) => {
                      return (
                        <Input
                          ref={(element) => this._checkboxes.push(element)}
                          checked={
                            fixedFilters[aggregation.id]
                              ? fixedFilters[aggregation.id].includes(
                                  bucket.key
                                )
                              : false
                          }
                          type="checkbox"
                          name={aggregation.id}
                          value={bucket.key}
                          label={
                            bucket.key === "HBO"
                              ? `Legacy HBO (${bucket.docCount})`
                              : `${bucket.key} (${bucket.docCount})`
                          }
                          key={bucket.key}
                          onChange={this._handleCheckboxChange}
                        />
                      );
                    })}
                  </CollapsibleItem>
                );
              }
            })}
        </Collapsible>
      </div>
    );
  }
}

export default Aggregations;
